import { ReactNode } from "react";

interface Props {
  icon: string;
  tone: "success" | "danger";
  title: string;
  message: ReactNode;
  confirmLabel: string;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const TONES = {
  success: { iconBg: "#dcfce7", iconColor: "#16a34a", btn: "dp-btn--success" },
  danger:  { iconBg: "#fee2e2", iconColor: "#dc2626", btn: "dp-btn--danger" },
};

export default function ConfirmSheet({ icon, tone, title, message, confirmLabel, busy, onConfirm, onClose }: Props) {
  const t = TONES[tone];
  return (
    <div className="dp-overlay" onClick={() => !busy && onClose()}>
      <div className="dp-sheet" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="dp-sheet__handle" />
        <div className="dp-sheet__icon" style={{ background: t.iconBg, color: t.iconColor }}>
          <i className={`bi ${icon}`}></i>
        </div>
        <div className="dp-sheet__title">{title}</div>
        <div className="dp-sheet__text">{message}</div>
        <div className="dp-sheet__actions">
          <button className="dp-btn dp-btn--ghost" onClick={onClose} disabled={busy}>Vazgeç</button>
          <button className={`dp-btn ${t.btn}`} onClick={onConfirm} disabled={busy}>
            {busy ? <span className="spinner-border spinner-border-sm" role="status" /> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
